import { deleteRequest, postRequest, putRequest } from ".";
import apiEndpoints from "./apiEndpoints";

export const uploadFileRequest = (payload) =>
  postRequest(apiEndpoints.files.uploadFile, payload);
export const updateFileRequest = (payload) =>
  putRequest(apiEndpoints.files.uploadFile + "/update-note/" + payload.id, {note: payload.data});
export const deleteFileRequest = (id) =>
  deleteRequest(apiEndpoints.files.deleteFile + "/" + id);
